import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-property',
  templateUrl: './skeleton-property.component.html',
  styleUrls: ['./skeleton-property.component.scss'],
  standalone: false
})
export class SkeletonPropertyComponent implements OnInit {
  dummydata: any = ['','',''];
  constructor() { }

  ngOnInit() {}

}
